export const mergeEmailContentResponse = (baseEmail, response) => {
  return {
    ...baseEmail,
    body: response?.body,
    bodyContentType: response?.bodyContentType,
    webLink: response?.webLink ?? baseEmail?.webLink,
    provider: response?.provider ?? baseEmail?.provider,
    isUnread: response?.isUnread ?? baseEmail?.isUnread,
  };
};
